import jwplayer from '@media/types/JwPlayer';
import { AudioItem } from '../../types/getAudio';
import { VideoItem } from '../../types/getVideo';

import { GoogleAnalytics } from '@analytics/trackers';
import { loadScript } from '../loadScript';
import PlayerAnalytics from './BaseAnalytics';

import config from '../../config/media.config';

interface gAwindow extends Window {
  [index: string]: any;
}

declare let window: gAwindow;

class gaTracker extends PlayerAnalytics {
  private _ga!: GoogleAnalytics;

  constructor(player: jwplayer.JWPlayer, mediaData: AudioItem | VideoItem) {
    super(player, mediaData);
  }

  initAnalytics() {
    if (!window.ga) {
      loadScript({ script: '//www.google-analytics.com/analytics.js', attr: { async: 'async' } }).then(() => {
        this.initGa();
      });
    } else {
      this.initGa();
    }
    this.setEventsListeners();
  }

  private initGa() {
    this._ga = new GoogleAnalytics();
    this._ga.create(config.analytics.ga.uid);
    this._ga.pageView();
    this.sendEvent('media_ready');
  }

  private setDimensions() {
    const parameters = this.eventParameters();
    return {
      dimension1: parameters.media_id,
      dimension2: parameters.media_type,
      dimension3: parameters.media_title,
      dimension4: parameters.media_authors,
      dimension5: parameters.media_autoplay,
      dimension6: parameters.media_muted,
      dimension7: parameters.media_mutestart,
      dimension8: String(parameters.media_position),
    };
  }

  public sendEvent(eventName: string) {
    const category = `Portal media: ${this._mediaData.type}`;
    const title = document.title || this._mediaData.metadata.title;
    const label = `${title} vd:${this._mediaData.id}`;
    const dimensions = this.setDimensions();
    this._ga.event(category, eventName, label, dimensions);
  }
}

export { gaTracker };
